<template>
  <div class="recordDetail">
    <van-steps direction="vertical">
      <van-step>
        <template #active-icon>
          <img src="@/assets/images/bluepoint.png" alt />
        </template>
        <div class="item">提交申请</div>
        <div class="step first">
          <div class="top">{{ detailData.fullName }}</div>
          <div class="bot">
            <span>{{ detailData.serviceName }}</span>
            <span>
              {{
              detailData.createTime | getDate("YYYY-MM-DD &nbsp; HH:mm")
              }}
            </span>
          </div>
        </div>
      </van-step>
      <van-step v-if="detailData.applyStatus === '2' || detailData.applyStatus === '3'">
        <template #inactive-icon>
          <img src="@/assets/images/yellowpoint.png" alt />
        </template>
        <div class="item">审核{{ detailData.applyStatus === "2" ? "通过" : "不通过" }}</div>
        <div class="step second">
          <div class="top">南京东路街道管理人员</div>
          <div class="bot">{{ detailData.permitDate | getDate("YYYY-MM-DD &nbsp; HH:mm") }}</div>
        </div>
      </van-step>
      <van-step v-if="detailData.applyStatus === '3'">
        <template #inactive-icon>
          <img src="@/assets/images/redpoint.png" alt />
        </template>
        <div class="item">不通过原因：</div>
        <div class="step third">{{ detailData.refuseCause }}</div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import { getRecoredDetail } from "@/api/service.js";
export default {
  name: "recordDetail",
  data() {
    return {
      detailData: {}
    };
  },
  methods: {
    async getData() {
      const { data } = await getRecoredDetail(this.$route.query.id);
      this.detailData = data;
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.recordDetail {
  padding-top: 20px;
  padding-left: 20px;
  .van-steps {
    .van-step {
      .item {
        height: 22px;
        opacity: 1;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #543302;
      }
      .step {
        &.second {
          background-color: #ffedbb;
          .top {
            width: 140px;
            height: 20px;
            opacity: 1;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #543302;
          }
          .bot {
            width: 114px;
            height: 17px;
            opacity: 0.75;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #543302;
            margin-left: 158px;
          }
        }
        margin-top: 18px;
        width: 306px;
        height: 83px;
        opacity: 1;
        background: #d2eeff;
        border-radius: 8px;
        padding-top: 14px;
        padding-left: 16px;
        &.third {
          background-color: #f1f1f0;
          height: 94px;
          padding-right: 66px;
          opacity: 0.67;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: left;
          color: #543302;
        }
        .top {
          width: 36px;
          height: 17px;
          opacity: 1;
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: left;
          color: #543302;
        }
        .bot {
          margin-top: 20px;
          span {
            width: 112px;
            height: 20px;
            opacity: 1;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #543302;
            &:nth-child(2) {
              margin-left: 51px;
              width: 114px;
              height: 17px;
              opacity: 0.75;
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-Bold;
              font-weight: 700;
              text-align: left;
              color: #543302;
            }
          }
        }
      }
      img {
        width: 18px;
        height: 18px;
        opacity: 1;
      }
    }
  }
}
</style>
